import React from 'react'

function About() {
    return (
       <>
            <div class="card mb-3">
  <div class="row g-0">
    <div class="col-md-4 mt-5">
      <img src="/images/mypic.jpg"  style={{width:'28rem', height:'25rem'}} class="img-fluid rounded-start" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title text-center">About me</h5>
        <p class="card-text text-center">My name is Parag Coimbatore. I am a software developer. I am awesome. </p>
        <p class="card-text text-center">"CONNECT WITH ME"</p>
        <p class="card-text text-center">Instagram:- iiparagcoimbatoreii</p>
        <p class="card-text text-center">Whatsapp:- 9876543210 </p>
        
      </div>
    </div>
  </div>
</div>
       </>
            
    )
}

export default About
